import { render } from "./MedalReminderModal.vue?vue&type=template&id=3e8cac42&scoped=true"
import script from "./MedalReminderModal.vue?vue&type=script&lang=js"
export * from "./MedalReminderModal.vue?vue&type=script&lang=js"

import "./MedalReminderModal.vue?vue&type=style&index=0&id=3e8cac42&scoped=true&lang=css"

import exportComponent from "/tmp/build_5ac5815b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8cac42"]])

export default __exports__